export default __webpack_public_path__ + "static/media/logo-white.99c288f6.png";